import { Button } from '@cleartax/wg-library-button';
import { SimpleDropdown } from '@cleartax/wg-library-simple-dropdown';
import { Text } from '@cleartax/wg-library-typography';
import { useRouter } from 'next/router';
import { trackAction } from '../../../../../utils';
import { MyAccountDropdown } from '../my-account-dropdown';

export const LoggedOutSection: React.FC = () => {
  const router = useRouter();
  const returnPath = Buffer.from(router.asPath as string).toString('base64');
  return (
    <>
      <Text
        className="text-brand-1000 pr-6"
        type="a"
        href="https://www.clear.in/s/contact-us"
        onClick={() =>
          trackAction('click', '', { label: 'top_nav_menu_Support' })
        }
      >
        Support
      </Text>
      <Text
        type="a"
        href={`${process.env.NEXT_PUBLIC_SSO_ENDPOINT}&return_path=${returnPath}`}
      >
        <Button
          variant="blue"
          rounded={'lg'}
          className="text-brand-1000 bg-brand-200 border-none"
          onClick={() =>
            trackAction('click', '', { label: 'top_nav_menu_Login/Register' })
          }
        >
          Login/Register
        </Button>
      </Text>
    </>
  );
};

export const LoggedInSection: React.FC = () => {
  return (
    <div className="flex items-center">
      <Text
        className="text-brand-1000 pr-6 whitespace-nowrap"
        type="a"
        href="/services/my_orders"
        onClick={() =>
          trackAction('click', '', { label: 'top_nav_menu_My Orders' })
        }
      >
        My Orders
      </Text>
      <SimpleDropdown
        dropDownText="My Account"
        dropdownContent={<MyAccountDropdown />}
        className="text-brand-1000 whitespace-nowrap"
      ></SimpleDropdown>
    </div>
  );
};
